<template>
    <div>
        <div>
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i> Фильтр</span><span class="rc"><i
                            class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span>Параметры фильтра</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <!---------------------год------------------------->
                            <div class="filter-block">
                                <b-form-group label="Год">
                                    <multiselect
                                        v-model="repYear"
                                        placeholder="Выберите год"
                                        :options="yearList"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        ref="yearRef"
                                        @input="loadRegions"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <!---------------------регион------------------------->
                            <div class="filter-block">
                                <b-form-group label="Регион">
                                    <multiselect
                                        v-if="listReg"
                                        v-model="reg"
                                        track-by="code"
                                        label="name"
                                        placeholder="Регион"
                                        :options="listReg"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                    >
                                    </multiselect>
                                    <span v-else class="input-style"></span>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-form-group label="Категория">
                                    <multiselect
                                        v-model="repKat"
                                        track-by="code"
                                        label="name_ru"
                                        placeholder="Выбрать категорию"
                                        :options="repKatOpt"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgRepKat"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-form-group label="Класс">
                                    <multiselect
                                        v-model="repCls"
                                        track-by="code"
                                        label="name_ru"
                                        placeholder="Выбрать класс"
                                        :options="repClsOpt"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgRepCls"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-form-group label="Подкласс">
                                    <multiselect
                                        v-model="repSubCls"
                                        track-by="code"
                                        label="name_ru"
                                        placeholder="Выбрать Подкласс"
                                        :options="repSubClsOpt"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgRepSubCls"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-form-group label="Специфика">
                                    <multiselect
                                        v-model="repSpec"
                                        track-by="code"
                                        label="name_ru"
                                        placeholder="Выбрать специфику"
                                        :options="repSpecOpt"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="chgRepSpec"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-button variant="primary" @click="chgData">Применить</b-button>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
                <div class="filter-actions">
                    <b-button v-if="haveImportAccess" variant="danger" @click="clearTree()">Очистить таблицу</b-button>
                    <b-button v-if="haveEditAccess" variant="success" :disabled="isLoad" @click="prepareForSave">Сохранить</b-button>
                    <b-button v-if="operationCode.length > 0" v-show="agrEnabled" variant="success" @click="agreementEvent">Действия</b-button>
                </div>
            </div>
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" @click="openHistory(currentForm)" v-if="currentForm && currentForm.hasOwnProperty('status') && currentForm.status">
                    {{ getLocalStatus(currentForm) }}
                </span>
                <span class="item-breadcrumb" @click="openFilterByRef('yearRef')">
                    {{ repYear }}
                </span>
                <span v-if="reg && reg.hasOwnProperty('code') && reg.code" class="item-breadcrumb" @click="openFilterByRef('regionRef')">
                    {{ reg.code }}-{{ reg.name_ru }}
                </span>
                <span v-if="repKat && repKat.hasOwnProperty('code') && repKat.code" class="item-breadcrumb" @click="openFilterByRef('regionRef')">
                    {{ repKat.code }}-КАТ
                </span>
                <span v-if="repCls && repCls.hasOwnProperty('code') && repCls.code" class="item-breadcrumb" @click="openFilterByRef('regionRef')">
                    {{ repCls.code }}-КЛ
                </span>
                <span v-if="repSubCls && repSubCls.hasOwnProperty('code') && repSubCls.code" class="item-breadcrumb" @click="openFilterByRef('regionRef')">
                    {{ repSubCls.code }}-ПКЛ
                </span>
                <span v-if="repSpec && repSpec.hasOwnProperty('code') && repSpec.code" class="item-breadcrumb" @click="openFilterByRef('regionRef')">
                    {{ repSpec.code }}-СПП
                </span>

            </div>
        </div>

        <div>
            <a v-if="haveEditAccess" class="badge badge-primary" style="position: absolute; z-index: 1; top: 15px; right: 10px;cursor: pointer" @click=" showAddItemModal = !showAddItemModal">   добавить +   </a>
            <a v-if="haveImportAccess && !budgetForm.length" class="badge badge-primary" style="position: absolute; z-index: 1; top: 15px; right: 105px;cursor: pointer" @click="importIncome"> Импортировать </a>
            <b-progress variant="primary" v-show="bar<100" height="3px" :value="bar" striped animated></b-progress>
            <div class="table-card table-container b-table-sticky-header">
                <table class="table b-table table-hover table-bordered table-sm b-table-no-border-collapse">
                    <thead>
                        <tr>
                            <th v-for="tname in tableFields" :key="tname.key">
                                <template v-if="tname.key === 'action'">
                                    <b-button @click="openAll()">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="open"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="!open"></i>
                                    </b-button>
                                </template>
                                <template v-else>
                                    {{ tname.label }}
                                </template>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(data, index) in budgetForm" :key="index"
                            :class="{
                            'is-hidden': !data.visible,
                            '': data.visible,
                            'table-info': data.type === 1,
                            'pr-level': data.type === 2,
                            'ppr-level': data.type === 3
                            }"
                        >
                            <template>
                                <td class="text-right"  v-if="data.type === 1">
                                    <b-button @click="openChilds(data)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="data.open"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="!data.open"></i>
                                    </b-button>
                                </td>
                                <td colspan="2" class="text-right"  v-else-if="data.type === 2">
                                    <b-button @click="openChilds(data)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="data.open"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="!data.open"></i>
                                    </b-button>
                                </td>
                                <td colspan="3" class="text-right"  v-else-if="data.type === 3">
                                    <b-button @click="openChilds(data)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="data.open"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="!data.open"></i>
                                    </b-button>
                                </td>
                                <td v-else colspan="4"></td>
                            </template>
                            <template>
                                <td colspan="4" v-if="data.type === 1">
                                <div v-if="data.type === 1">
                                    {{ data.kat }} - {{ data.name_ru }}
                                </div>
                                </td>
                            </template>
                            <template>
                                <td colspan="3" v-if="data.type === 2">
                                    <div v-if="data.type === 2">
                                        {{ data.clss > 9 ? data.clss : "0" + data.clss }} - {{ data.name_ru }}
                                    </div>
                                </td>
                            </template>
                            <template>
                                <td colspan="2" v-if="data.type === 3">
                                    <div v-if="data.type === 3">
                                        {{ data.pcl }} - {{ data.name_ru }}
                                    </div>
                                </td>
                            </template>
                            <template>
                                <td colspan="1" v-if="data.type === 5">
                                    <div
                                        title="Разноска годовой суммы бюджета по месяцам"
                                        style="cursor:pointer;"
                                        v-if="(haveEditAccess) && data.income_data > 0"
                                        variant="light"
                                        @click="openModal(data)">
                                        <span>{{ data.spf > 9 ? data.spf : "0" + data.spf }} - {{ data.name_ru }} <img width="20px" height="20px" title=""
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABmJLR0QA/wD/AP+gvaeTAAAC4ElEQVR4nO3dzW4TMRiF4VPUHUJcBa0oW3Ys4IZbiWaJeklUSqBlWRaJRBORGU8+27F93keyFCmZydg+mvyMx5YAAAAAAAAAAAAAAAAAAAAAAMDoriXdSdpIeumsbHbHfkV9T3Mt6bGBikXLY2KjuNV31l0DlclVbqnvvouEBtlIepfwuh5sJL1PeI1NfVMC8JLnWJoxV2er+r6pdRRoEwEwRwDMXWbYR8r3iJpKf4YPVV/OAOYIgDkCYI4AmCMA5giAOQJgjgCYIwDmCIA5AmCOAJgjAOYIgDkCYG7EAPyaeG5dYfuujBiAHxPPPVTYfjhzY89bc6X/39iReqNEdPvaivdPbwGQth11q+0pe717/KHi9jURgA58krSS9CzpSdK9pJtM+yYAjbvR9ixy2G5rSV8y7J8ANO5ex9tuo3gICEDjnjTdftEQEIDGzQUgGgIC0Ljvmm/DSAgIQOOOfQnMFQIC0IHPkn4qLQS/JX1bsO8uA9DzHDw1ypIzQXcBGGUOntJlrbQ/i7oLwEhz8JQuq4T2DPVPjililt4uPdIcPKX9kfRW030Q6p8RLwdjgXMEYOp6O/Y9KNPneETu7wDHrrdT9sta0seE9szdP1Xe4PX19nM3dItl6J+Bjpb+EfR1wb4JQOP4K9jcSuU6Xwn7DSMAp7vQ9rd8qc5Xwr7DCMDpUgLAgJDBTX0EMCTMAINCoRv9Gxb+vHvMsPCCXo83iK4ZlH0NnswIwIFj4w2iawZxa1ipN8hsarxBdM2glO1rIwAHpoaZpdzeHd2+tlD/nGNASGnR47WqLwNCzBEAcwTAHAEwRwDMEQBzBMAcATBHAMwRAHMEwBwBMEcAzBEAcwTA3GWGfbQ4KKSkoerLGcAcATBHAMylBGBqDZ3eRNcM6s1sfVMCMNKcPtE1g3qTZY2jUeb0ia4Z1FvJeiNLz3P6RNcMOvfx16gvAAAAAAAAAAAAAAAAAAAAAADo0F/5tv2gZkObIAAAAABJRU5ErkJggg=="
                                                   alt=""></span>
                                    </div>
                                    <div v-else>
                                        {{ data.spf > 9 ? data.spf : "0" + data.spf }} - {{ data.name_ru }}
                                    </div>
                                </td>
                            </template>
                            <template>
                               <td>
                                   <div class="text-right">
                                       {{ $n(data.income_data) }}
                                   </div>
                               </td>
                            </template>
                            <template>
                               <td>
                                   <template>
                                       <div title="Внимание! Расхождение по суммам!" v-if="(parseFloat(data.deviation) !== parseFloat(data.income_data)) && !empty_total" class="text-right"
                                            :class="{ 'error-deviation': (parseFloat(data.deviation) !== parseFloat(data.income_data)) && !empty_total }">
                                           {{ $n(data.deviation) }}
                                       </div>
                                       <div v-else class="text-right">
                                           {{ $n(data.deviation) }}
                                       </div>
                                   </template>
                               </td>
                            </template>

                            <td v-for="mon in calcFlds.slice(2)" :key="mon">
                                <template v-if="(data.type === 5)">
                                    <div>
                                        <b-form-input
                                            v-if="haveEditAccess"
                                            class="text-right"
                                            :value="$n(data[mon])"
                                            @change="v => data[mon] = parseFloat(v.replace(/[^0-9]/g, ''))"
                                            @keyup.enter.exact="keyup13"
                                            @keypress="keyPress($event, '^[0-9]+$')"
                                            @blur="inputFixed(data, mon, data[mon])">
                                        </b-form-input>
                                        <div v-else class="text-right">
                                            {{ $n(data[mon]) }}
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-right">
                                        {{ $n(data[mon]) }}
                                    </div>
                                </template>
                            </td>
                            <td>
                                <template v-if="data.type === 1 && data.newItem">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        dropleft class="more"
                                    >
                                        <template v-slot:button-content>
                                            <i class="icon icon-more"></i>
                                        </template>
                                        <template>
                                            <b-dropdown-item
                                                @click="deleteSpec(data)">
                                                Удалить категорию
                                            </b-dropdown-item>
                                        </template>
                                    </b-dropdown>
                                </template>
                                <template v-if="data.type === 2 && data.newItem">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        dropleft class="more"
                                    >
                                        <template v-slot:button-content>
                                            <i class="icon icon-more"></i>
                                        </template>
                                        <template>
                                            <b-dropdown-item
                                                @click="deleteSpec(data)">
                                                Удалить класс
                                            </b-dropdown-item>
                                        </template>
                                    </b-dropdown>
                                </template>
                                <template v-if="data.type === 3 && data.newItem">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        dropleft class="more"
                                    >
                                        <template v-slot:button-content>
                                            <i class="icon icon-more"></i>
                                        </template>
                                        <template>
                                            <b-dropdown-item
                                                @click="deleteSpec(data)">
                                                Удалить подкласс
                                            </b-dropdown-item>
                                        </template>
                                    </b-dropdown>
                                </template>
                                <template v-if="data.type === 5 && haveDeleteAccess">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        dropleft class="more"
                                    >
                                        <template v-slot:button-content>
                                            <i class="icon icon-more"></i>
                                        </template>
                                        <template>
                                            <b-dropdown-item
                                                @click="deleteSpec(data)">
                                                Удалить специфику
                                            </b-dropdown-item>
                                        </template>
                                    </b-dropdown>
                                </template>

                            </td>

                        </tr>
                        <template v-if="katLastData">
                            <tr>
                                <td colspan="1" class="text-right">
                                    <b-button @click="katLastData.open(!katLastData.collapse)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="!katLastData.collapse"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="katLastData.collapse"></i>
                                    </b-button>
                                </td>
                                <td colspan="4">
                                    <div>
                                        {{ katLastData.kat }} - {{ katLastData.name_ru }}
                                    </div>
                                </td>
                                <td>
                                    <div class="text-right"></div>
                                </td>
                                <td>
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf.deviation) }}
                                    </div>
                                </td>
                                <td v-for="mon in calcFlds.slice(2)" :key="mon">
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf[mon]) }}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-if="!katLastData.collapse">
                                <td colspan="2" class="text-right">
                                    <b-button @click="katLastData.cls.open(!katLastData.cls.collapse)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="!katLastData.cls.collapse"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="katLastData.cls.collapse"></i>
                                    </b-button>
                                </td>
                                <td colspan="3">
                                    <div>
                                        {{ katLastData.cls.clss > 9 ? katLastData.cls.clss : "0" + katLastData.cls.clss }} - {{ katLastData.cls.name_ru }}
                                    </div>
                                </td>
                                <td>
                                    <div class="text-right"></div>
                                </td>
                                <td>
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf.deviation) }}
                                    </div>
                                </td>
                                <td v-for="mon in calcFlds.slice(2)" :key="mon">
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf[mon]) }}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-if="!katLastData.cls.collapse">
                                <td colspan="3" class="text-right">
                                    <b-button @click="katLastData.cls.pcl.open(!katLastData.cls.pcl.collapse)">
                                        <i class="icon icon-keyboard icon-rotate-270" v-if="!katLastData.cls.pcl.collapse"></i>
                                        <i class="icon icon-keyboard icon-rotate-90" v-if="katLastData.cls.pcl.collapse"></i>
                                    </b-button>
                                </td>
                                <td colspan="2">
                                    <div>
                                        {{ katLastData.cls.pcl.pcl }} - {{ katLastData.cls.pcl.name_ru }}
                                    </div>
                                </td>
                                <td>
                                    <div class="text-right"></div>
                                </td>
                                <td>
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf.deviation) }}
                                    </div>
                                </td>
                                <td v-for="mon in calcFlds.slice(2)" :key="mon">
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf[mon]) }}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-if="!katLastData.cls.pcl.collapse">
                                <td colspan="4" class="text-right"></td>
                                <td colspan="1">
                                    <div>
                                        {{ katLastData.cls.pcl.spf.spf > 9 ? katLastData.cls.pcl.spf.spf : "0" + katLastData.cls.pcl.spf.spf }} - {{ katLastData.cls.pcl.spf.name_ru }}
                                    </div>
                                </td>
                                <td>
                                    <div class="text-right"></div>
                                </td>
                                <td>
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf.deviation) }}
                                    </div>
                                </td>
                                <td v-for="mon in calcFlds.slice(2)" :key="mon">
                                    <div class="text-right">
                                        {{ $n(katLastData.cls.pcl.spf[mon]) }}
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        </template>
                        <tr>
                                <td></td>
                                <td class="text-left font-weight-bold" colspan="4">Итого (тыс. теңге)</td>
                                <td class="text-right font-weight-bold">{{ $n(total('income_data', false)) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('deviation')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('january')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('february')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('march')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('april')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('may')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('june')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('july')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('august')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('september')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('october')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('november')) }}</td>
                                <td class="text-right font-weight-bold">{{ $n(total('december')) }}</td>
                                <td></td>
                            </tr>

                    </tbody>
                </table>
            </div>
        </div>
        <c-income-add-item-modal
            v-if="reg && reg.hasOwnProperty('code') && reg.code && showAddItemModal"
            ref="addItemRef"
            :data-table="budgetForm"
            :filter-kat="repKat"
            :filter-clss="repCls"
            :filter-spf="repSpec"
            :filter-pcl="repSubCls"
            :filter-year="repYear"
            :filter-region="reg.code"
            :is-empty-total="empty_total"
            @addItemClk="addNewItems"
            @shown="showAddItemModal = false"
        ></c-income-add-item-modal>
        <import-from-file-modal
            v-if="reg && reg.hasOwnProperty('code') && reg.code"
            :cur-year="repYear"
            :cur-month="0"
            :cur-region="reg.code"
            @shown="showImportFileModal = false"
            @importTableIncome="importTableIncome"
            :show="showImportFileModal"
            :request-id="null"
        ></import-from-file-modal>
        <c-budg-agr-modal
            ref="refAgrModal"
            :agr-btn-lst="agrBtnLst"
            @agrClk="agrClick"
        ></c-budg-agr-modal>
        <b-exec-agr-hist-modal ref="refHistModal" :mode_code="'exspf'" :status-types="statusList"/>
    </div>
</template>

<script>
import store from '@/services/store';
import { Ax } from '@/utils';
import axios from 'axios'
import CIncomeAddItemModal from '@/modules/budget/execution/form/tabs/components/IncomeAddItemModal.vue';
import CBudgetAgreementModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue";
import IncomeImportFromFileModal from '@/modules/budget/execution/form/tabs/components/IncomeImportFromFileModal.vue';
import BExecAgrHistModal from '@/modules/budget/execution/form/tabs/components/BExecAgrHistModal.vue'
import { EventBus } from '@/modules/budget/eventBus'


export default {
    $refs: {
        refHistModal: HTMLFormElement
    },
    name: 'BudgetExecutionIncome',
    components: {
        'c-income-add-item-modal': CIncomeAddItemModal,
        'c-budg-agr-modal': CBudgetAgreementModal,
        'import-from-file-modal': IncomeImportFromFileModal,
        'b-exec-agr-hist-modal': BExecAgrHistModal
    },
    props: { obl: null },
    data() {
        return {
            tableFields: [
                {
                    key: 'action',
                    label: ' '
                },
                {
                    key: 'kat',
                    label: 'Категория'
                },
                {
                    key: 'clss',
                    label: 'Класс'
                },
                {
                    key: 'pcl',
                    label: 'Подкласс'
                },
                {
                    key: 'spf',
                    label: 'Специфика'
                },
                {
                    key: 'income_data',
                    label: 'доходы'
                },
                {
                    key: 'deviation',
                    label: 'Финансовый план на год',
                    variant: 'danger'
                },
                {
                    key: 'january',
                    label: 'Январь'
                },
                {
                    key: 'february',
                    label: 'Февраль'
                },
                {
                    key: 'march',
                    label: 'Март'
                },
                {
                    key: 'april',
                    label: 'Апрель'
                },
                {
                    key: 'may',
                    label: 'Май'
                },
                {
                    key: 'june',
                    label: 'Июнь'
                },
                {
                    key: 'july',
                    label: 'Июль'
                },
                {
                    key: 'august',
                    label: 'Август'
                },
                {
                    key: 'september',
                    label: 'Сентябрь'
                },
                {
                    key: 'october',
                    label: 'Октябрь'
                },
                {
                    key: 'november',
                    label: 'Ноябрь'
                },
                {
                    key: 'december',
                    label: 'Декабрь'
                },
                {
                    key: 'more',
                    label: ''
                }
            ],
            calcFlds: [
                'income_data',
                'deviation',
                'january',
                'february',
                'march',
                'april',
                'may',
                'june',
                'july',
                'august',
                'september',
                'october',
                'november',
                'december'
            ],

            filter: {
                kat: null,
                clss: null,
                pcl: null,
                spf: null,
                name_ru: null
            },

            onYearRegChange: true,
            yearList: [],
            repYear: 0,
            repFilterData: {},
            repKat: {
                name: 'Все',
                code: null
            },
            repKatOpt: [],
            maxKat: 0,

            repCls: {
                name: 'Все',
                code: null
            },
            repClsOpt: [],

            repSubCls: {
                name: 'Все',
                code: null
            },
            repSubClsOpt: [],

            repSpec: {
                name: 'Все',
                code: null
            },
            repSpecOpt: [],
            listReg: null,
            reg: null,
            filtered: false,

            months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],

            bar: 0,
            dictTree: null,
            budgetForm: [],
            open: true,
            isLoad: false,
            empty_total: false,
            moduleCode: '005.001.003',
            editAccess: null,
            signAccess: false,
            saveAccess: false,
            showAddItemModal: false,
            uniqueId: 0,

            currentForm: null,
            spfForm: null,
            statusList: [],
            selectedStatus: null,
            operationCode: [],
            agrBtnLst: { back: [], forward: [] },
            selectArr: [],
            agrEnabled: false,
            mode: 'exspp',
            form: 'spp',

            showImportFileModal: false,

            spfData: [],
            spfObj: {
                income_data: 0,
                deviation: 0,
                january: 0,
                february: 0,
                march: 0,
                april: 0,
                may: 0,
                june: 0,
                july: 0,
                august: 0,
                september: 0,
                october: 0,
                november: 0,
                december: 0
            },
            katLastData: null,
            queryParams: null

        };
    },

    async created() {

        this.queryParams = this.$route.query;

        const curDate = new Date()
        this.repYear = curDate.getFullYear();
        for (let i = 2022; i <= this.repYear; i++) {
            this.yearList.push(i);
        }
        if (curDate.getMonth() > 9) {
            this.yearList.push(this.repYear + 1)
            this.repYear += 1
        }
        if (this.queryParams?.year) {
            this.repYear = parseInt(this.queryParams.year)
        }

        await this.loadRegions();
        if (this.queryParams) {
            if (this.queryParams.region) {
                const f_region = this.listReg.find(it => it.code === this.queryParams.region);
                if (f_region) {
                    this.reg = f_region;
                } else {
                    this.reg = null;
                    this.makeToast('danger', "Доступ", "Внимание!. Регион не доступен")
                }
            }
        }
        if (!this.editAccess) this.getEditAccess();
        this.statusList = await this.getStatusList(this.mode)
        this.$watch('repYear', () => {
            this.onYearRegChange = true;
        })
        this.$watch('reg', () => {
            this.onYearRegChange = true;
        }, {deep: true})
        this.$emit('curYear', this.repYear);
        EventBus.$on('formSPFChanged', (formData) => {
            if (formData.region === this.currentForm.region && formData.year === this.currentForm.year) {
                this.getCurrentSpf()
            }
        });
        this.$watch('currentForm', async () => {
            await this.agreementEvent(false);
        }, { deep: true });
        this.$emit('registerComponent', this, this.form)
        await this.loadOperations();
        await this.getCurrentForm()
        await this.getCurrentSpf()
        await this.loadDictTree();
        await this.loadRepFilterData()
        await this.getSpfTotal()
        await this.loadLastKat()
        this.bar = 100;
        this.queryParams = null

    },

    async mounted() {

    },

    beforeUpdate() {
        this.budgetForm.forEach(row => {
            if ([0, 1, 2, 3].includes(row.type)) {
                row._rowVariant = 'info';
            }
        });
    },

    methods: {
        getEditAccess() {
            const avModules = store.state.user.userModules
            for (const avModule of avModules) {
                if (avModule.modules === this.moduleCode) {
                    this.editAccess = Object.assign({}, avModule)
                    break
                }
            }
        },

        switchTab(isExternal = false) {
            try {
                const tabConfig = {
                    name: this.$route.name,
                    params: {
                        form: this.form
                    },
                    query: {}
                }
                let hasChanges = false;
                hasChanges = hasChanges || this.$route.params.form !== this.form
                if (!this.queryParams) {
                    if (this.currentForm) {
                        tabConfig.query.region = this.currentForm.region
                        tabConfig.query.year = this.currentForm.year
                    }
                } else {
                    tabConfig.query.region = this.queryParams?.region
                    tabConfig.query.year = this.queryParams?.year
                }
                hasChanges = hasChanges || this.$route.query?.region  !== tabConfig.query.region
                hasChanges = hasChanges || this.$route.query?.year  !== tabConfig.query.year
                if (hasChanges) {
                    this.$router.replace(tabConfig)
                }
            } catch (error) {}
        },

        async loadRegions() {
            try {
                this.bar = 40;
                const response = await fetch(`/api-py/get-user-regions-by-obl/${this.obl}/${store.state.user.sub}/${this.repYear}`);
                this.listReg = await response.json();
                for (let i = 0; i < this.listReg.length; i++) {
                    this.listReg[i].name = this.listReg[i].code + ' - ' + this.listReg[i].name_ru
                }
                if (this.listReg.length > 0) {
                    this.reg = this.listReg[0]
                }
                this.reg = this.listReg[0]
                this.bar = 100;
            } catch (error) {
                this.bar = 100;
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }
        }, // справочник регионов
        deleteSpfRemote(item) {
            const path = '/api/consolidated-income-plan'
            const deleteItems = [];
            const obj = {
                code: "",
                region: this.reg.code,
                year: this.repYear,
                id: item.id,
                kat: item.kat,
                clss: item.clss,
                pcl: item.pcl,
                spf: item.spf
            }
            deleteItems.push(obj)
            axios.delete(path, {data: deleteItems})
            .then(response => {
                console.log('Delete request successful');
            })
            .catch(error => {
                console.error('Error making delete request:', error.message);
            });
        },
        deleteSpec(data) {
            const el = Object.assign({}, data)
            for (let i = 0; i < this.budgetForm.length; i++) {
                if (this.budgetForm[i].id === data.id) {
                    if (this.budgetForm[i].type === 5 && !this.budgetForm[i].newItem) {
                        this.$bvModal.msgBoxConfirm(
                            'Вы действительно хотите удалить данную запись?',
                            {
                                title: 'Подтверждение',
                                size: 'lg',
                                buttonSize: 'sm',
                                okVariant: 'success',
                                okTitle: 'ДА',
                                cancelTitle: 'Отмена',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                            .then(value => {
                                if (value) {
                                    this.budgetForm.splice(i, 1);
                                    i--;
                                    this.deleteSpfRemote(el)
                                }
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    } else {
                        this.budgetForm.splice(i, 1);
                        i--;
                    }
                    // this.budgetForm.splice(i, 1);
                    // i--;
                } else if (this.budgetForm[i].parent_id === data.id) {
                    for (let j = 0; j < this.budgetForm.length; j++) {
                        if (this.budgetForm[j].parent_id === this.budgetForm[i].id) {
                            if (data.type === 1) {
                                for (let k = j; k < this.budgetForm.length; k++) {
                                    if (this.budgetForm[k].parent_id === this.budgetForm[j].id) {
                                        this.budgetForm.splice(k, 1);
                                        k--;
                                    }
                                }
                            }
                            this.budgetForm.splice(j, 1);
                            j--;
                        }
                    }
                    this.budgetForm.splice(i, 1);
                    i--;
                }
            }
        },
        createTable(elem, parent_id, idx = null) {
            const that = this;
            // создание таблицы на основе дерева
            const item = Object.assign({}, elem);

            this.uniqueId++;
            this.$set(item, 'id', this.uniqueId);
            this.$set(item, 'parent_id', parent_id);
            this.$set(item, 'visible', true);
            Object.defineProperty(item, 'parent', {
                get: function () {
                    for (const row of that.budgetForm) {
                        if (item.parent_id === row.id) {
                            return row;
                        }
                    }
                    return null;
                }
            });

            if (item.type === 5) {
                this.calcFlds.forEach((field) => {
                    if (item.hasOwnProperty(field)) {
                        if (!item[field]) {
                            this.$set(item, field, 0);
                        } else {
                            this.$set(item, field, parseFloat(item[field]));
                        }
                    } else {
                        if (field === 'deviation') {
                            Object.defineProperty(item, 'deviation', {
                                get: function () {
                                    const sum = (parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june)
                                        + parseFloat(item.july) + parseFloat(item.august) + parseFloat(item.september)
                                        + parseFloat(item.october) + parseFloat(item.november) + parseFloat(item.december));
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });


                            Object.defineProperty(item, 'checkFeb', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkMar', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkApr', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkMay', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkJun', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkJul', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkAug', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july)
                                        + parseFloat(item.august);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkSep', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july)
                                        + parseFloat(item.august) + parseFloat(item.september);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkOct', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july)
                                        + parseFloat(item.august) + parseFloat(item.september) + parseFloat(item.october);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkNov', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july)
                                        + parseFloat(item.august) + parseFloat(item.september) + parseFloat(item.october)
                                        + parseFloat(item.november);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                            Object.defineProperty(item, 'checkDec', {
                                get: function () {
                                    const sum = parseFloat(item.january) + parseFloat(item.february) + parseFloat(item.march)
                                        + parseFloat(item.april) + parseFloat(item.may) + parseFloat(item.june) + parseFloat(item.july)
                                        + parseFloat(item.august) + parseFloat(item.september) + parseFloat(item.october)
                                        + parseFloat(item.november) + parseFloat(item.december);
                                    return parseFloat((Math.round(sum * 10) / 10).toFixed(1));
                                }
                            });
                        } else {
                            this.$set(item, field, 0);
                        }
                    }
                });
            } else {
                this.$set(item, 'open', true);
                this.$set(item, 'hasChild', true);

                this.calcFlds.forEach(field => {
                    Object.defineProperty(item, field, {
                        get: function () {
                            return that.reSum(item, field);
                        }
                    });
                });
            }

            if (item) {
                this.$set(item, 'index', this.budgetForm.length);
                if (idx === null) {
                    this.$set(this.budgetForm, this.budgetForm.length, item);
                } else {
                    this.budgetForm.splice(idx, 0, item)
                }
            }
            if (idx !== null) return
            if (item.hasChild) {
                switch (item.type) {
                    case 1:
                        item.child_list.sort((a, b) => a.clss - b.clss);
                        break
                    case 2:
                        item.child_list.sort((a, b) => a.pcl - b.pcl);
                        break
                    case 3:
                        item.child_list.sort((a, b) => a.spf - b.spf);
                        break

                }
                for (const ch of item.child_list) {
                    this.createTable(ch, item.id);
                }
                delete item.child_list;
            }
        }, // древовидную выборку преобразовывает в таблицу (для отображения)

        addNewKatClssPclSpf(item, parentIndex = 0, type, desc, create = false) {
            let isExist = false;
            let rowIndex = 0
            const parent = this.budgetForm[parentIndex]
            for (let i = parentIndex; i < this.budgetForm.length; i++) {
                const el = this.budgetForm[i]
                if (el.type === type && el[desc] === item[desc] && (type === 1 ? true: el.parent_id === parent.id)) {
                    isExist = true
                    rowIndex = i
                    break
                }
            }
            if (!isExist) {
                let dataItem = {}
                this.uniqueId++;
                dataItem = {
                    id: this.uniqueId,
                    year: 2023,
                    region: this.reg.code,
                    kat: item.kat,
                    clss: type > 1 ? item.clss : null,
                    pcl: type > 2 ? item.pcl : null,
                    spf: type > 3 ? item.spf : null,
                    name_ru: type === 1 ? item.katName: (type === 2 ? item.clssName: (type === 3 ? item.pclName: item.name_ru)),
                    type: type,
                    income_data: 0.0,
                    month: [],
                    hasChanges: true,
                    newItem: true
                }
                this.calcFlds.slice(2).forEach((calcF, index) => {
                    const val = item[calcF]? item[calcF]: 0
                    dataItem[calcF] = val
                    dataItem.month.push({
                        month: index,
                        value: val
                    })
                })
                this.uniqueId++;
                let lowIndex = this.budgetForm.length
                for (let i = type === 1 ? 0: parentIndex+1; i < this.budgetForm.length; i++) {
                    const el = this.budgetForm[i]
                    if (el.type <= parent.type && type !== 1) {
                        lowIndex = i;
                        break;
                    }
                    if (el.type === type && item[desc] < el[desc] && (type === 1 ? true: el.parent_id === parent.id)) {
                        lowIndex = i;
                        break;
                    }
                }
                this.createTable(dataItem, type === 1 ? 0: parent.id, lowIndex)
                rowIndex = lowIndex
            }

            if (parent !== undefined && !parent.open && type !== 1) this.openChilds(parent);
            return rowIndex;
        },

        addNewItem(item, create = false) {
            this.uniqueId++;
            const newItem = {
                id: this.uniqueId,
                ...item
            }

            const katIndex = this.addNewKatClssPclSpf(newItem, 0, 1, 'kat', create)
            const clssIndex = this.addNewKatClssPclSpf(newItem, katIndex, 2, 'clss', create)
            const pclIndex = this.addNewKatClssPclSpf(newItem, clssIndex, 3, 'pcl', create)
            this.addNewKatClssPclSpf(newItem, pclIndex, 5, 'spf', create)
            for (let i = 0; i < this.budgetForm.length; i++) {
                this.budgetForm[i].index = i
            }

        },

        addNewItems(items) {
            for (const item of items) {
                this.addNewItem(item)
            }
        },

        sortedTable(item) {
            if ([1, 2, 3].includes(item.type)) {
                for (const ch of item.child_list) {
                    this.sortedTable(ch)
                }
            } else {
                this.addNewItem(item, true)
            }
        },

        openModal(item) {
            this.$bvModal.msgBoxConfirm(
                'Вы хотите выполнить разноску годовой суммы бюджета по месяцам?',
                {
                    title: 'Подтверждение',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'ДА',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        const monthlyShare = Math.floor(item.income_data / 12);
                        let newSum = 0;
                        for (const mon of this.months) {
                            item[mon] = parseInt(monthlyShare.toString())
                            newSum += item[mon]
                        }
                        const dif = item.income_data - newSum
                        if (dif !== 0) {
                            item.december += dif;
                        }
                        item.hasChanges = true
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        }, // открывает модалку в котором можно распределить значению план на год на 12 месяцев

        inputFixed(item, field, value) {
            item.hasChanges = true
            if (value) {
                this.$set(item, field, parseFloat(value));
            } else {
                this.$set(item, field, 0);
            }
        },

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            if (!event.target.value) {
                event.target.value = 0;
            }
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        keyPress: function (event, pattern) {
            // const regex = new RegExp('^[0-9]+$');
            // const regex = new RegExp('^-?\\d*\\d{0,9}$');
            // const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');

            const regex = new RegExp(pattern);
            const charCode = event.keyCode;
            const key = String.fromCharCode(charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            return true;
        }, // вводит по заданному паттерну

        async loadDictTree() {
            try {
                await this.budgetForm.splice(0);
                this.dictTree = null;
                this.bar = 60;
                let path = '/api/consolidated-income-plan?year=' + this.repYear + '&region=' + this.reg.code
                if (this.repKat && this.repKat.hasOwnProperty('code') && this.repKat.code) {
                    path += '&kat=' + this.repKat.code
                    if (this.repCls && this.repCls.hasOwnProperty('code') && this.repCls.code) {
                        path += '&cls=' + this.repCls.code
                        if (this.repSubCls && this.repSubCls.hasOwnProperty('code') && this.repSubCls.code) {
                            path += '&pcl=' + this.repSubCls.code
                            if (this.repSpec && this.repSpec.hasOwnProperty('code') && this.repSpec.code) {
                                path += '&spf=' + this.repSpec.code
                            }
                        }
                    }
                }
                // const response = await fetch('/api-py/budget-execution-income/dict-ebk-doh-tree/' + this.repYear + '/' + this.reg);
                const response = await fetch(path);
                this.dictTree = await response.json();
                this.bar = 80;
                this.prepareForm();
            } catch (error) {
                this.bar = 100;
                this.makeToast('danger', 'Ошибка запроса loadDictTree', error.toString());
            }
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение

        openAll(forceOpen) {
            if (forceOpen) {
                if (forceOpen === 'open') {
                    this.open = true;
                } else {
                    this.open = false;
                }
            } else {
                this.open = !this.open;
            }
            for (const row of this.budgetForm) {
                row.visible = this.open;
                if ([1, 2, 3, 4].includes(row.type)) {
                    row.open = this.open;
                }
                if ([0, 1].includes(row.type)) {
                    row.visible = true;
                }
            }
        }, // открывает.закрывает все ветки

        openChilds(parent, bool) {
            parent.open = (bool === undefined ? !parent.open : bool);

            for (const row of this.budgetForm) {
                if (parent.id === row.parent_id) {

                    row.visible = parent.open;
                    if (!parent.open) {
                        if ([1, 2, 3].includes(row.type)) {
                            this.openChilds(row, parent.open);
                        }
                    }

                }
            }
        }, // открывает/закрывает ветку до конечного элемента

        prepareForm() {
            this.dictTree.sort((a, b) => a.kat - b.kat)
            for (const item of this.dictTree) {
                this.createTable(item, 0);
            }
            this.empty_total = (this.budgetForm.length === 0 || this.total('income_data', false) === 0);
        }, // подготовка отображения данных

        reSum(parent, field) {
            let sum = 0;

            this.budgetForm.forEach(row => {
                if ((row.parent_id === parent.id)
                    && (row.type !== parent.type)) {
                    if (!row[field]) {
                        sum += 0;
                    } else {
                        sum += parseFloat(row[field]);
                    }
                    // sum += parseFloat(row[field]);
                }
            });
            return parseFloat(sum.toFixed(2));
        }, // пересчет суммы

        rowClass(item, type) {
            if (!item || type !== 'row') {
                return;
            }
            if (!item.visible) {
                return 'is-hidden';
            }
        }, // задает класс 'is-hidden' заданной строке

        toNum(value, fix = 1) {
            if (typeof (value) === 'string') {
                return parseFloat(parseFloat(value).toFixed(fix));
            }
            if (typeof (value) === 'number') {
                return parseFloat(value.toFixed(fix));
            }
            if (typeof (value) === 'boolean') {
                return (value === true ? 1 : 0);
            }
            if (typeof (value) === 'undefined' || isNaN(value) || isFinite(value) || (value === null)) {
                return 0;
            }
        },

        total(field, include8kat = true) {
            let sum = 0;
            for (const row of this.budgetForm) {
                if (row.type === 1) {
                    sum += parseFloat(row[field]);
                }
            }
            if (include8kat && this.katLastData) sum += this.katLastData.cls.pcl.spf[field];
            return parseFloat(sum.toFixed(2));
        }, // итого по заданному полю

        //= ========== фильтрация данных в столбцах ===============

        filterFunction(row, val) {
            const { kat, clss, pcl, spf, name_ru } = val;
            const isOpen = [
                !kat || Number(kat) === row.kat,
                !clss || Number(clss) === row.clss,
                !pcl || Number(pcl) === row.pcl,
                !spf || Number(spf) === row.spf,
                !name_ru || row.name_ru.toLowerCase().indexOf(name_ru.toLowerCase()) !== -1
            ].every(Boolean);
            if ((kat || clss || pcl || spf || name_ru) && !this.filtered) {
                this.filtered = true;
                this.openAll('open');
            }
            if (!(kat || clss || pcl || spf || name_ru) && this.filtered) {
                this.filtered = false;
                this.openAll('close');
            }
            return isOpen;
        },

        async prepareForSave() {
            this.isLoad = true;
            const dataToSave = {
                user_name: '',
                user_id: this.$store.state.user.sub,
                region: this.reg.code,
                year: this.repYear,
                execution_income_list: []
            };

            let errorRow = false;
            let katParent = null;
            let clssParent = null;
            let pclParent = null;
            this.budgetForm.forEach(el => {
                if (el.type === 1) katParent = el
                if (el.type === 2) clssParent = el
                if (el.type === 3) pclParent = el

                if (el.type === 5 && (el.hasChanges || el.newItem)) {
                    // save anyway but allert if not equal
                    const isValid = (parseFloat(katParent.deviation) !== parseFloat(katParent.income_data) && parseFloat(clssParent.deviation) !== parseFloat(clssParent.income_data) && parseFloat(pclParent.deviation) !== parseFloat(pclParent.income_data)) || this.empty_total
                    // const isValid = (parseFloat(katParent.deviation) <= parseFloat(katParent.income_data) && parseFloat(clssParent.deviation) <= parseFloat(clssParent.income_data) && parseFloat(pclParent.deviation) <= parseFloat(pclParent.income_data)) || this.empty_total
                    let newAndEmpty = true;
                    this.months.forEach(m => {
                        if (el[m] !== 0) newAndEmpty = false;
                    })

                    const elItem = {};
                    elItem.code = '';
                    elItem.region = this.reg.code;
                    elItem.year = this.repYear;
                    elItem.id = el.id;
                    elItem.kat = el.kat;
                    elItem.clss = el.clss;
                    elItem.pcl = el.pcl;
                    elItem.spf = el.spf;
                    this.months.forEach(month => elItem[month] = el[month]);

                    dataToSave.execution_income_list.push(elItem);
                    if ((isValid || (el.newItem && newAndEmpty))) {
                        errorRow = true;
                    }
                }
            });

            if (dataToSave.execution_income_list && dataToSave.execution_income_list.length > 0) {
                await this.save(dataToSave.execution_income_list, errorRow);
            } else {
                this.makeToast('success', 'Сообщение', 'Нету измененных данных');
                this.isLoad = false;
            }
            await this.saveLastKat()
        }, // подготовка данных к сохранению

        async save(values, error = false) {
            try {
                const response = await fetch('/api/consolidated-income-plan', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(values)
                });
                // const result = await response.json();
                if (response.status === 200) {
                    if (error && !this.empty_total) {
                        this.makeToast('warning', 'Сообщение', 'Сводный план поступлений сохранен, но имеет расхождения!');
                        await this.chgData();
                    } else {
                        this.makeToast('success', 'Сообщение', 'Сводный план поступлений сохранен успешно');
                        await this.chgData();
                    }
                } else {
                    throw 'Ошибка сохранения данных. Возможно не все обязательные поля заполнены';
                }
            } catch (e) {
                this.makeToast('danger', 'Предупреждение', e.toString());
            } finally {
                this.isLoad = false;
            }
        }, // сохранение данных

        async chgData() {
            this.$refs.drop.hide(true);
            await this.getCurrentForm()
            await this.getCurrentSpf()
            this.switchTab()
            this.uniqueId = 0;
            await this.loadDictTree();
            await this.loadRepFilterData()
            this.onYearRegChange = false;
            await this.getSpfTotal()
            await this.loadLastKat()
            this.bar = 100;
            this.$emit('curYear', this.repYear);
        },
        async chgRepKat() {
            this.repClsOpt = []
            this.repSubClsOpt = []
            this.repSpecOpt = []
            this.repCls = null
            this.repSubCls = null
            this.repSpec = null
            if (!(this.repKat && this.repKat.hasOwnProperty('code') && this.repKat.code)) return
            await this.loadClsOpt()

        },
        async chgRepCls() {
            this.repSubClsOpt = []
            this.repSpecOpt = []
            this.repSubCls = null
            this.repSpec = null
            if (!(this.repCls && this.repCls.hasOwnProperty('code') && this.repCls.code)) return
            await this.loadPclOpt()
        },
        async chgRepSubCls() {
            this.repSpec = null
            this.repSpecOpt = []
            if (!(this.repSubCls && this.repSubCls.hasOwnProperty('code') && this.repSubCls.code)) return
            await this.loadSpfOpt()
        },
        chgRepSpec() {
            console.log('last filter item')
        },
        async setLastKat() {
            const path = `/api-py/get-dict-doh-childs-by-parent/0/${this.repYear}`
            const base = await axios.get(path).then(resp => {
                return resp.data
            })

            this.maxKat = Math.max(...base.map((item) => item.kat))
        },
        async loadKatOpt() {
            await this.setLastKat()
            const req = {
                year: this.repYear,
                region: this.reg.code
            }
            const path = `/api-py/budget-execution-income/filter`
            let data = []
            await axios.get(path, {
                params: req
            }).then(resp => {
                data = resp.data
                data = data.filter(item => item.kat !== this.maxKat)
            })
            this.repKatOpt = [
                {
                    name_ru: 'Все',
                    code: null
                }
            ]
            for (const re of data) {
                this.repKatOpt.push(
                    {
                        kat: re.kat,
                        code: re.kat,
                        name_ru: `${re.kat} - ${re.name_ru}`
                    }
                )
            }
            this.repKat = {
                name_ru: 'Все',
                code: null
            }
            if (this.repKatOpt.length === 1) {
                this.repKatOpt = []
                this.repKat = null
            }
        },
        async loadClsOpt() {
            const req = {
                year: this.repYear,
                region: this.reg.code,
                kat: this.repKat.code
            }
            const path = `/api-py/budget-execution-income/filter`
            let data = []
            await axios.get(path, {
                params: req
            }).then(resp => {
                data = resp.data
            })
            this.repClsOpt = [
                {
                    name_ru: 'Все',
                    code: null
                }
            ]
            for (const re of data) {
                this.repClsOpt.push(
                    {
                        cls: re.cls,
                        code: re.cls,
                        name_ru: `${re.cls} - ${re.name_ru}`
                    }
                )
            }
            this.repCls = {
                name_ru: 'Все',
                code: null
            }
            if (this.repClsOpt.length === 1) {
                this.repClsOpt = []
                this.repCls = null
            }
        },
        async loadPclOpt() {
            const req = {
                year: this.repYear,
                region: this.reg.code,
                kat: this.repKat.code,
                cls: this.repCls.code
            }
            const path = `/api-py/budget-execution-income/filter`
            let data = []
            await axios.get(path, {
                params: req
            }).then(resp => {
                data = resp.data
            })
            this.repSubClsOpt = [
                {
                    name_ru: 'Все',
                    code: null
                }
            ]

            for (const re of data) {
                this.repSubClsOpt.push(
                    {
                        pcl: re.pcl,
                        code: re.pcl,
                        name_ru: `${re.pcl} - ${re.name_ru}`
                    }
                )
            }
            this.repSubCls = {
                name_ru: 'Все',
                code: null
            }
            if (this.repSubClsOpt.length === 1) {
                this.repSubClsOpt = []
                this.repSubCls = null
            }
        },
        async loadSpfOpt() {
            const req = {
                year: this.repYear,
                region: this.reg.code,
                kat: this.repKat.code,
                cls: this.repCls.code,
                pcl: this.repSubCls.code,
            }
            const path = `/api-py/budget-execution-income/filter`
            let data = []
            await axios.get(path, {
                params: req
            }).then(resp => {
                data = resp.data
            })
            this.repSpecOpt = [
                {
                    name_ru: 'Все',
                    code: null
                }
            ]
            for (const re of data) {
                this.repSpecOpt.push(
                    {
                        spf: re.spf,
                        code: re.spf,
                        name_ru: `${re.spf} - ${re.name_ru}`
                    }
                )
            }
            this.repSpec = {
                name_ru: 'Все',
                code: null
            }
            if (this.repSpecOpt.length === 1) {
                this.repSpecOpt = []
                this.repSpec = null
            }
        },
        async loadRepFilterData() {
            if (!this.onYearRegChange) return
            this.repKatOpt = []
            this.repKat = null
            this.repClsOpt = []
            this.repCls = null
            this.repSubClsOpt = []
            this.repSubCls = null
            this.repSpecOpt = []
            this.repSpec = null
            this.loadKatOpt()
        },
        kat() {
            const res = []
            for (const re of this.repKatOpt) {
                res.push({
                    kat: re.kat,
                    code: re.kat,
                    name_ru: `${re.kat} - ${re.name_ru}`
                })
            }
            return res
        },
        cls() {
            const res = []
            for (const re of this.repClsOpt) {
                res.push({
                    cls: re.cls,
                    code: re.cls,
                    name_ru: `${re.cls} - ${re.name_ru}`
                })
            }
            return res
        },
        pcl() {
            const res = []
            for (const re of this.repSubCls) {
                res.push({
                    pcl: re.pcl,
                    code: re.pcl,
                    name_ru: `${re.pcl} - ${re.name_ru}`
                })
            }
            return res
        },
        spf() {
            const res = []
            for (const re of this.repSpecOpt) {
                res.push({
                    spf: re.spf,
                    code: re.spf,
                    name_ru: `${re.spf} - ${re.name_ru}`
                })
            }
            return res
        },

        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            const refItem = this.$refs[refName];
            setTimeout(() => refItem.$el.focus(), 100);
        },

        downloadIISKReport(app) {
            const url = `/api/budget-execution-base/xls?addAllAgreed=false&addIpf=${app % 2? 'false': 'true'}&addSpp=true&year=${this.repYear}&region=${this.reg.code}&code=${app % 2? 'SP_PB': 'UTV_P_MB&level=UF'}&${app % 2? 'planType=INCOME': 'type=PAYMENT&dataLevel=PRG'}`
            Ax(
                {
                    url: url,
                    method: 'GET',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', app === 6? `Утвержденный план_${this.reg.code}_${this.repYear}.xls` : `СПП${app === 7? `(Категория${this.katLastData.kat})`: ''}_${this.reg.code}_${this.repYear}.xls`);
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepPayments()', error.toString());
                }
            );
        },

        downloadRepConsolidatedIncomePlan14() {
            const param = {
                year: this.repYear,
                region_id: this.reg.code
            };
            Ax(
                {
                    url: '/api-py/download-consolidated-income-plan/14/' + JSON.stringify(param),
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план поступлений в бюджет.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepConsolidatedIncomePlan14()', error.toString());
                }
            );
        },

        downloadRepConsolidatedIncomePlan15() {
            const param = {
                year: this.repYear,
                region_id: this.reg.code
            };
            Ax(
                {
                    url: '/api-py/download-consolidated-income-plan/15/' + JSON.stringify(param),
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Сводный план поступлений в бюджет.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRepConsolidatedIncomePlan15()', error.toString());
                }
            );
        },

        async getCurrentForm() {
            if (this.reg && this.reg.hasOwnProperty('code') && this.reg.code) {
                await axios.get(`/api/budget-execution-pf-request/income?year=${this.repYear}&region=${this.reg.code}`)
                    .then(resp => {
                        if (resp.status === 200) {
                            this.currentForm = resp.data
                        }
                    })
            }
        },
        async getStatusList(mode) {
            try {
                let statusList = [];
                const response = await axios.get(`/api-py/get-status-list/${mode}`);
                if (response.status === 200) {
                    statusList = response.data;
                }
                return statusList;
            } catch (e) {
                console.error("Error fetching status list:", e);
                return [];
            }
        },
        flk0Agr() {
          return this.total('deviation', false) > 0
        },
        async agrClick(data) {
            if (data.status === 26) {
                if (this.spfForm && this.spfForm.hasOwnProperty('status') && this.spfForm.status) {
                    if (![26, 39].includes(this.spfForm.status.status)) {
                        this.makeToast('danger', 'Согласование', 'Сводный план финансирования не согласован!')
                        return;
                    }
                }
                const totalSpf = await this.getSpfTotal(true)
                const flk0 = this.flk0Agr()
                if (totalSpf !== this.total('deviation', false) || !flk0) {
                    if (!flk0) {
                        this.makeToast('danger', 'Согласование', 'Данное действие не доступно')
                        return;
                    }
                    this.makeToast('warning', 'Согласование', 'Сводный план поступлений и финансирования по платежам должен быть сбалансирован')
                    return;
                }
            }
            await axios.post(
                '/api/budget-execution-pf-status',
                {
                    budgetExecutionPfId: this.currentForm.id,
                    comment: data.commentTxt,
                    status: data.status
                }
            ).then(res => {
                if (res.status === 200) {
                    this.chgData()
                    EventBus.$emit('formSPPChanged', this.currentForm)
                }
            }).catch(e => {
                if (e.response.data?.key === 'modules.budgetExecutionPf.error.isNotEqualSPFtoSPP') {
                    this.makeToast('warning', 'Согласование', 'Сводный план поступлений и финансирования по платежам должен быть сбалансирован')
                }
            })
        },
        async loadOperations() {
            this.operationCode = [];
            if (store.state.user.sub === null) { return; }
            let result = null;
            try {
                result = await fetch(encodeURI(`/api/um/module/link?user=${store.state.user.sub}&modulecode=${this.moduleCode}`))
                    .then(response => response.json());
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки операций пользователя', error.toString());
                return;
            }
            if (result.operations) { this.operationCode = result.operations; }
        },
        async agreementEvent(show = true) {
            this.selectArr = [];
            const params = { modeCode: this.mode, operationCode: this.operationCode, agrCode: this.currentForm.status.status };
            if (!show) { this.agrEnabled = false; }
            let result = [];
            try {
                const response = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
                result = await response.json();
            } catch (error) {
                // this.makeToast('danger', 'Ошибка get-agreement-step-next-back', 'Ошибка загрузки шагов согласования!');
                return;
            }
            if (result.length === 0) {
                this.makeToast('warning', 'Согласование', 'Нет доступных шагов согласования!');
                return;
            }
            this.agrBtnLst = { back: [], forward: [] };

            for (const el of result) {
                if (el.stepType === 1) {
                    this.agrBtnLst.back.push(el);
                } else {
                    this.agrBtnLst.forward.push(el);
                }
            }
            if (this.agrBtnLst.back.length || this.agrBtnLst.forward.length) {
                this.agrEnabled = true;
            }
            if (show) {
                // eslint-disable-next-line
                // @ts-ignore
                this.$refs.refAgrModal.showEvent();
            }
        },
        async openHistory(agrObj) {
            if (agrObj !== null) {
                await this.$refs.refHistModal.showEvent(agrObj);
            }
        },
        getFullName(row) {
            if (row.gu) {
                return `индивидуальный план финансирования на ${row.year} по ${row.gu}`
            }
            return `индивидуальный план финансирования на ${row.year}`
        },
        getLocalStatus(value) {
            const status = value.status.status;
            const curStatus = this.statusList.filter((item) => item.code === status);
            if (!curStatus || !curStatus.length) return status;
            const localName = curStatus[0]["name_" + this.$i18n.locale];
            return localName;
        },

        async getCurrentSpf() {
            await axios.get(`/api/budget-execution-pf-request/UF?year=${this.repYear}&region=${this.reg.code}`)
                .then(resp => {
                    if (resp.status === 200) {
                        this.spfForm = resp.data
                    }
                })
        },

        async getSpfTotal(calc = false) {
            const queryString = {
                year: this.repYear,
                region: this.reg.code,
                type: 'payment',
            };
            if (this.spfForm && this.spfForm.hasOwnProperty('status') && this.spfForm.status.status === 39) queryString.status = 39;
            else queryString.status = 32;
            let total = 0;
            let data = [];
            await axios.get('/api/budget-execution/spf', {params: queryString})
                .then(resp => {
                    if (resp.status === 200) {
                        data = resp.data
                        this.spfData = data
                    }
                })
            if (!calc) {
                this.buildLastKat()
                return 0
            }
            if (data.length) {
                for (const d of data) {
                    total += d.plan
                }
            }
            return total
        },
        importIncome() {
            this.showImportFileModal = true
        },
        async importTableIncome(importData) {
            const data = importData.data
            const error = importData.error
            if (error.incorrectRows) {
                this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию и исправьте ошибки.')
                return
            }
            if (error.negativeValue) {
                this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют отрицательные значения')
                return
            }
            if (error.duplicationError) {
                const duplicates = error.duplicates;
                const text = duplicates.map(val => `${val.kat}->${val.cls}->${val.pcl}->${val.spf}`).join('\n')
                this.makeToast('danger', 'Импорт', 'Ошибка в данных! Пожалуйста, перепроверьте введенную информацию присутствуют дубли')
                return
            }
            if (error.lastKatError) {
                this.makeToast('warning', 'Импорт', `Внимание! Файл содержит данные по ${this.katLastData.kat} категории. Данные не импортированы для данной категории.`)
            }
            if (!data.length) {
                this.makeToast('danger', 'Импорт', 'Пустая таблица. Пожалуйста, добавьте данные.')
                return
            }
            this.budgetForm = []
            this.addNewItems(data)
        },
        async clearTree() {
            this.$bvModal.msgBoxConfirm(
                'Вы хотите удалить данные безвозвратно?',
                {
                    title: 'Подтверждение',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'ДА',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async (value) => {
                    if (value) {
                        const deleteItems = []
                        const path = '/api/consolidated-income-plan'
                        for (const item of this.budgetForm) {
                            if (item.type === 5 && !item.newItem) {
                                const obj = {
                                    code: "",
                                    region: this.reg.code,
                                    year: this.repYear,
                                    id: item.id,
                                    kat: item.kat,
                                    clss: item.clss,
                                    pcl: item.pcl,
                                    spf: item.spf
                                }
                                deleteItems.push(obj)
                            }
                        }
                        if (!deleteItems.length) {
                            this.makeToast('warning', 'Удаление', 'Невозможно удалить данные. данные отсутсвуют!')
                            return;
                        }

                        await axios.delete(path, {data: deleteItems})
                            .then(response => {
                                if (response.status === 200) {
                                    this.budgetForm = []
                                    this.makeToast('info', 'Удаление', 'Данные успешно удалены!')
                                }
                            })
                            .catch(error => {
                                this.makeToast('danger', 'Удаление', 'Не удалось удалить данные!')
                            });
                    }
                })
                .catch(error => {
                    console.log(error);
                });

        },
        async loadLastKat() {
            const total = (field) => {
                let sum = 0;
                for (const row of this.budgetForm) {
                    if (row.type === 1) {
                        sum += parseFloat(row[field]);
                    }
                }
                return parseFloat(sum.toFixed(2));
            }
            let data = {}
            let kat = null;
            let cls = null;
            let pcl = null;
            let spf = null;
            const filter = {
                year: this.repYear,
                region: this.reg.code,
                code: '',
                collapse: true
            }

            await axios.get(`/api-py/get-dict-doh-childs-by-parent/0/${this.repYear}/${this.reg.code}`).then(resp => {
                if (resp.status === 200) {
                    let maxKat = 0
                    for (const el of resp.data) {
                        if (el.kat > maxKat) {
                            maxKat = el.kat
                            kat = el
                        }
                    }
                }
            }).catch(error => {})
            if (kat) {
                await axios.get(`/api-py/get-dict-doh-childs-by-parent/${kat.id}/${this.repYear}/${this.reg.code}`).then(resp => {
                    if (resp.status === 200) {
                        cls = resp.data.find(it => it.clss === 1)
                    }
                }).catch(error => {})
            }
            if (cls) {
                await axios.get(`/api-py/get-dict-doh-childs-by-parent/${cls.id}/${this.repYear}/${this.reg.code}`).then(resp => {
                    if (resp.status === 200) {
                        pcl = resp.data.find(it => it.pcl === 1)
                    }
                }).catch(error => {})
            }
            if (pcl) {
                await axios.get(`/api-py/get-dict-doh-childs-by-parent/${pcl.id}/${this.repYear}/${this.reg.code}`).then(resp => {
                    if (resp.status === 200) {
                        spf = resp.data.find(it => it.spf === 1)
                    }
                }).catch(error => {})
            }
            if (!spf) return;
            data = Object.assign(filter, kat)

            data.cls = Object.assign({
                year: this.repYear,
                region: this.reg.code,
                code: '',
                collapse: true
            }, cls)
            data.cls.pcl = Object.assign({
                year: this.repYear,
                region: this.reg.code,
                code: '',
                collapse: true
            }, pcl)
            data.cls.pcl.spf = Object.assign({
                year: this.repYear,
                region: this.reg.code,
                code: '',
                collapse: true
            }, spf)
            const that = this
            Object.defineProperty(data.cls.pcl.spf, 'income_data', {
                get: function () {
                    return that.spfObj.income_data - total('income_data')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'deviation', {
                get: function () {
                    return that.spfObj.deviation - total('deviation')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'january', {
                get: function () {
                    return that.spfObj.january - total('january')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'february', {
                get: function () {
                    return that.spfObj.february - total('february')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'march', {
                get: function () {
                    return that.spfObj.march - total('march')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'april', {
                get: function () {
                    return that.spfObj.april - total('april')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'may', {
                get: function () {
                    return that.spfObj.may - total('may')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'june', {
                get: function () {
                    return that.spfObj.june - total('june')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'july', {
                get: function () {
                    return that.spfObj.july - total('july')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'august', {
                get: function () {
                    return that.spfObj.august - total('august')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'september', {
                get: function () {
                    return that.spfObj.september - total('september')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'october', {
                get: function () {
                    return that.spfObj.october - total('october')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'november', {
                get: function () {
                    return that.spfObj.november - total('november')
                }
            })
            Object.defineProperty(data.cls.pcl.spf, 'december', {
                get: function () {
                    return that.spfObj.december - total('december')
                }
            })
            data.cls.pcl.open = function (collapse) {
                data.cls.pcl.collapse = collapse
            }
            data.cls.open = function (collapse) {
                data.cls.collapse = collapse
                if (collapse) {
                    data.cls.pcl.open(collapse)
                }
            }
            data.open = function (collapse) {
                data.collapse = collapse
                if (collapse) {
                    data.cls.open(collapse)
                    data.cls.pcl.open(collapse)
                }
            }
            this.katLastData = data
        },
        buildLastKat() {
            const spfObj = {
                income_data: 0,
                deviation: 0,
                january: 0,
                february: 0,
                march: 0,
                april: 0,
                may: 0,
                june: 0,
                july: 0,
                august: 0,
                september: 0,
                october: 0,
                november: 0,
                december: 0
            }
            for (const d of this.spfData) {
                spfObj.deviation += d.plan
                spfObj.january += d.january
                spfObj.february += d.february
                spfObj.march += d.march
                spfObj.april += d.april
                spfObj.may += d.may
                spfObj.june += d.june
                spfObj.july += d.july
                spfObj.august += d.august
                spfObj.september += d.september
                spfObj.october += d.october
                spfObj.november += d.november
                spfObj.december += d.december
            }
            this.spfObj = spfObj
        },
        async saveLastKat() {
            const spfObj = {
                year: this.repYear,
                region: this.reg.code,
                code: '',
                kat: this.katLastData.kat,
                clss: 1,
                pcl: 1,
                spf: 1,
                id: 0,
            }
            for (const mon of this.months) {
                spfObj[mon] = this.katLastData.cls.pcl.spf[mon]
            }
            await this.save([spfObj])
        }
    },

    computed: {
        haveEditAccess() {
            return this.currentForm && this.currentForm.hasOwnProperty('status') && this.currentForm.status !== null && [1, 27].includes(this.currentForm.status.status) && this.editAccess && (this.editAccess.access_level === 2 || this.editAccess.access_level === 3)
        },
        haveDeleteAccess() {
            return this.currentForm && this.currentForm.hasOwnProperty('status') && this.currentForm.status !== null && [1, 27].includes(this.currentForm.status.status) && this.editAccess && (this.editAccess.access_level === 2 || this.editAccess.access_level === 3)
        },
        haveImportAccess() {
            return this.operationCode.includes("imp_execution") && this.haveEditAccess
        }
    }
};
</script>

<style scoped>
.filtered {
    color: #95B8CD;
    display: inline-block;
    margin-right: 5px;
}
.pr-level {
    background-color: #ecf7ff
}
.ppr-level {
    background-color: rgba(236, 247, 255, 0.6)
}
.data-expand {
    position: absolute;
    top: 0;
    right: 0;
}

.error-deviation {
    color: #C0504C;
}
</style>